import { forwardRef, type Ref, type SVGProps } from "react";
const IconLeafFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M29.71 2.29a1 1 0 0 0-.89-.29c-.66.12-16.22 3-20.71 7.45A13.6 13.6 0 0 0 4 17.3a9.2 9.2 0 0 0 2.11 7.16l-3.82 3.83a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0l3.82-3.83a9.15 9.15 0 0 0 6 2.18A10 10 0 0 0 14.7 28a13.6 13.6 0 0 0 7.83-4.1C27 19.4 29.87 3.84 30 3.18a1 1 0 0 0-.29-.89m-9 10.42-11 11a1 1 0 0 1-1.42 0 1 1 0 0 1 0-1.42l11-11a1 1 0 0 1 1.42 1.42"
    />
  </svg>
);
const ForwardRef = forwardRef(IconLeafFilledSVG);
ForwardRef.displayName = "IconLeafFilled";
export { ForwardRef as IconLeafFilled };
